export const DEFAULT_BOARD_SIZE = 8;
export const DARK_SQUARE_PARITY = 1;

// Canvas + board geometry. The canvas is square; the board sits centered with a
// gutter on every side reserved for captured-piece piles and the turn banner.
export const CANVAS_SIZE = 720;
export const BOARD_OUTER_SIZE = 640;
export const BOARD_OUTER_OFFSET = (CANVAS_SIZE - BOARD_OUTER_SIZE) / 2;
export const WOOD_FRAME_THICKNESS = 32;
export const BOARD_INLAY_OFFSET = BOARD_OUTER_OFFSET + WOOD_FRAME_THICKNESS;
export const BOARD_INLAY_SIZE = BOARD_OUTER_SIZE - 2 * WOOD_FRAME_THICKNESS;
export const SQUARE_SIZE = BOARD_INLAY_SIZE / DEFAULT_BOARD_SIZE;

// Piece sizing.
export const PIECE_RADIUS = SQUARE_SIZE * 0.42;

// Animation timings (ms).
export const PIECE_MOVE_DURATION_MS = 280;
export const PIECE_HOP_DURATION_MS = 240;
export const PIECE_HOP_HEIGHT = 22;
export const PIECE_FADE_DURATION_MS = 200;
export const PIECE_PROMOTE_FLASH_MS = 220;

// Overlay magic numbers.
export const HOVER_GLOW_BLUR = 14;
export const GHOST_PIECE_ALPHA = 0.4;
export const MANDATORY_PULSE_PERIOD_MS = 1100;
